import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import * as React from "react";
import Swal from "sweetalert2";
import ButtonAppBar from "./Appbar";
var jwt = require("jsonwebtoken");
const axios = require("axios").default;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function App() {
  const MERCHANT_KEY = process.env.REACT_APP_MERCHANT_KEY;
  const REST_END_POINT = process.env.REACT_APP_END_POINT;
  const [amount, setAmount] = React.useState(0.0004);
  const [type, setType] = React.useState("BNB");
  const [address, setAddress] = React.useState(
    "0x2A1B53f3988c9574a5c93e5f0AF1bDfB1888030F"
  );
  const [tokenAddress, setTokenAddress] = React.useState(
    "0x55d398326f99059ff775485246999027b3197955"
  );
  const [customerId, setCustomerId] = React.useState("CUST003241");
  const [customerName, setCustomerName] = React.useState("Developer");
  const [customerEmail, setCustomerEmail] = React.useState(
    "developer@walletpayment.net"
  );
  const [customerPhone, setCustomerPhone] = React.useState("9876543210");
  const [value, setValue] = React.useState(0);
  const [coolingPeriod, setCoolingPeriod] = React.useState(30);
  const [minCoins, setMinCoins] = React.useState(0.002);
  const [maxCoins, setMaxCoins] = React.useState(1);
  const [isToken, setToken] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInternalRequest = () => {
    var token = jwt.sign(
      // {
      //   txnid: crypto.randomUUID(),
      //   amount: 0.2,
      //   type: "BNB",
      //   cid: "1",
      //   name: "Suresh ",
      //   email: "mr.suresh89@gmail.com",
      //   mobile: "9876543212",
      //   otherWallet: false,
      //   deductFromAdmin: true,
      //   deductBNB: true,
      //   successUrl:
      //     "https://radiuschain.net/er/rechargeSuccess.php?user_id=10539&amount=10",
      //   failureUrl: "https://radiuschain.net/rr/rechargeFailer.php",
      //   webhookUrl: "http://radiuschain.net/te/webhook.php",
      //   tokenAddress: "0x55d398326f99059fF775485246999027B3197955",
      // },
      {
        txnid: crypto.randomUUID(),
        amount: 0.12,
        type: "BNB",
        cid: "1",
        name: "Suresh ",
        email: "mr.suresh89@gmail.com",
        mobile: "9876543212",
        otherWallet: true,
        deductFromAdmin: true,
        deductBNB: true,
        successUrl:
          "https://radiuschain.net/er/rechargeSuccess.php?user_id=10539&amount=10",
        failureUrl: "https://radiuschain.net/rr/rechargeFailer.php",
        webhookUrl: "http://radiuschain.net/te/webhook.php",
        tokenAddress: "0x55d398326f99059fF775485246999027B3197955",
      },
      MERCHANT_KEY,
      {
        issuer: "walletpayment.net",
        expiresIn: "200m",
      }
    );

    axios
      .post(
        REST_END_POINT + "/internal/transaction",
        {},
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Succes",
          html: response.data,
        });
        debugger;
      })
      .catch(function (err) {
        debugger;
        Swal.fire({
          icon: "error",
          title: "Error in Processing your request",
          html: err.response.data,
          footer: '<a href="">Why do I have this issue?</a>',
        });
      });
  };

  const handleBuyRequest = () => {
    var token = jwt.sign(
      {
        transactionId: crypto.randomUUID(),
        transactionCoins: 0.0002,
        transactionTokens: 0.02,
        transactionMode: "Buy",
        coinType: type,
        userEmail: customerEmail,
        userId: customerId,
        tokenAddress: tokenAddress,
        webhookUrl: "https://bscscan.com/address/",
      },
      MERCHANT_KEY,
      {
        issuer: "walletpayment.net",
        expiresIn: "200m",
      }
    );

    axios
      .post(
        REST_END_POINT + "/swap/token",
        {},
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        console.log(response.request.res.responseUrl);
        debugger;
      })
      .catch(function (err) {
        debugger;
        Swal.fire({
          icon: "error",
          title: "Error in Processing your request",
          html: err.response.data,
          footer: '<a href="">Why do I have this issue?</a>',
        });
      });
  };

  const handleWhitelist = () => {
    var token = jwt.sign(
      {
        address: address,
        type: type,
        customerName: customerName,
        customerEmail: customerEmail,
        customerPhone: customerPhone,
        customerId: customerId,
        minCoins: minCoins,
        maxCoins: maxCoins,
        coolingPeriod: coolingPeriod,
      },
      MERCHANT_KEY,
      {
        issuer: "walletpayment.net",
        expiresIn: "200m",
      }
    );

    axios
      .post(
        REST_END_POINT + "/whitelist",
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log(response.request.res.responseUrl);
        debugger;
      })
      .catch(function (err) {
        debugger;

        Swal.fire({
          icon: "error",
          title: "Error Occured",
          html: err.response.data.message,
          footer: '<a href="">Why do I have this issue?</a>',
        });
      });
  };

  const hanldeDeposit = () => {
    debugger;
    var token = jwt.sign(
      {
        txnid: "sureshrajy",
        amount: 0.2,
        type: "BNB",
        address: "0xf483bdb7Beb620B7b168F05836A8Db303eA713ad",
        cid: "1",
        name: "Suresh ",
        email: "sureshraju.may@gmail.com",
        mobile: "9876543212",
        successUrl:
          "https://radiuschain.net/er/rechargeSuccess.php?user_id=10539&amount=10",
        failureUrl: "https://radiuschain.net/rr/rechargeFailer.php",
        webhookUrl: "http://radiuschain.net/te/webhook.php",
        tokenAddress: "0x55d398326f99059fF775485246999027B3197955",
      },
      MERCHANT_KEY,
      {
        issuer: "walletpayment.net",
        expiresIn: "200m",
      }
    );

    axios
      .post(
        REST_END_POINT + "/deposits",
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((response) => {
        debugger;
        document.location.href = response.data;
      })
      .catch(function (err) {
        debugger;
        Swal.fire({
          icon: "error",
          title: "Error in Processing your request",
          html: err.response.data.message || err.response.data,
          footer: '<a href="">Why do I have this issue?</a>',
        });
      });
  };

  const hanldeCreate = () => {
    var token = jwt.sign(
      {
        coinType: type,
        userId: customerId,
        email: customerEmail,
      },
      MERCHANT_KEY,
      {
        issuer: "walletpayment.net",
        expiresIn: "200m",
      }
    );

    axios
      .post(
        REST_END_POINT + "/customer/wallet/create",
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        debugger;
        Swal.fire({
          icon: "success",
          title: "Wallet Created",
          text: "Wallet Created Successfully",
        });
      })
      .catch(function (err) {
        debugger;
        Swal.fire({
          icon: "error",
          title: "Error in Processing your request",
          html: err.response.data.message || err.response.data,
          footer: '<a href="">Why do I have this issue?</a>',
        });
      });
  };

  const handleWithdraw = () => {
    var token = jwt.sign(
      {
        txnid: crypto.randomUUID(),
        type: type,
        address: address,
        cid: customerId,
        name: customerName,
        email: customerEmail,
        mobile: customerPhone,
        amount: amount,
        successUrl:
          "https://Radiuschain.net/cryptoPaymentGateway/WithdrawSucess.php?user_id=10549&amount=2&wallettype=usdWallet",
        failureUrl:
          "https://Radiuschain.net/cryptoPaymentGateway/WithdrawFailed.php",
        webhookUrl:
          "https://Radiuschain.net/cryptoPaymentGateway/webhookForWithdrawal.php",
        tokenAddress: isToken ? tokenAddress : "",
      },
      MERCHANT_KEY,
      {
        issuer: "walletpayment.net",
        expiresIn: "200m",
      }
    );

    axios
      .post(
        REST_END_POINT + "/requests",
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Request sent Successfully",
          html: "Request will be processed soon",
          footer: '<a href="">Why do I have this issue?</a>',
        });
      })
      .catch(function (err) {
        Swal.fire({
          icon: "error",
          title: "Error in Processing your request",
          html: err.response.data,
          footer: '<a href="">Why do I have this issue?</a>',
        });
      });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <ButtonAppBar />
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Deposit" {...a11yProps(0)} />
          <Tab label="Whitelist" {...a11yProps(1)} />
          <Tab label="Withdraw" {...a11yProps(2)} />
          <Tab label="Create Wallet" {...a11yProps(3)} />
          <Tab label="Buy/Sell" {...a11yProps(4)} />
          <Tab label="Internal Transaction" {...a11yProps(5)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            hanldeDeposit();
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer ID"
                defaultValue={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Name"
                defaultValue={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Email"
                type="email"
                defaultValue={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Phone"
                defaultValue={customerPhone}
                onChange={(e) => setCustomerPhone(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Transaction Coins"
                defaultValue={amount}
                onChange={(e) => setAmount(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Wallet Type
                </InputLabel>
                <Select
                  value={type}
                  label="Wallet Type"
                  onChange={(e) => setType(e.target.value)}
                >
                  <MenuItem value={"BNB"}>BNB</MenuItem>
                  <MenuItem value={"BTC"}>BTC</MenuItem>
                  <MenuItem value={"TRX"}>TRX</MenuItem>
                  <MenuItem value={"USDT"}>USDT</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Checkbox
                checked={isToken}
                onChange={(e) => setToken(e.target.checked)}
              />
              Is Token Transfer
              {isToken && (
                <TextField
                  label="Contract Address"
                  defaultValue={tokenAddress}
                  onChange={(e) => setTokenAddress(e.target.value)}
                  fullWidth
                />
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button
                onClick={() => {
                  hanldeDeposit();
                }}
                fullWidth
                variant="contained"
              >
                Pay Now
              </Button>
            </Grid>
          </Grid>
        </form>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleWhitelist();
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer ID"
                defaultValue={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Name"
                defaultValue={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Email"
                type="email"
                defaultValue={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Phone"
                defaultValue={customerPhone}
                onChange={(e) => setCustomerPhone(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Wallet Type
                </InputLabel>
                <Select
                  value={type}
                  label="Wallet Type"
                  onChange={(e) => setType(e.target.value)}
                >
                  <MenuItem value={"BNB"}>BNB</MenuItem>
                  <MenuItem value={"BTC"}>BTC</MenuItem>
                  <MenuItem value={"TRX"}>TRX</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Wallet Address"
                defaultValue={address}
                onChange={(e) => setAddress(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Min Coins"
                defaultValue={minCoins}
                onChange={(e) => setMinCoins(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Max Coins"
                defaultValue={maxCoins}
                onChange={(e) => setMaxCoins(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Cooling Period (minutes)"
                defaultValue={coolingPeriod}
                onChange={(e) => setCoolingPeriod(e.target.value)}
                fullWidth
                helperText="for instant withdraw, please use -1"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button type="submit" fullWidth variant="contained">
                Whitelist Wallet
              </Button>
            </Grid>
          </Grid>
        </form>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleWithdraw();
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer ID"
                defaultValue={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Name"
                defaultValue={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Email"
                type="email"
                defaultValue={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Phone"
                defaultValue={customerPhone}
                onChange={(e) => setCustomerPhone(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Wallet Address"
                defaultValue={address}
                onChange={(e) => setAddress(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Transaction Coins"
                defaultValue={amount}
                onChange={(e) => setAmount(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Wallet Type
                </InputLabel>
                <Select
                  value={type}
                  label="Wallet Type"
                  onChange={(e) => setType(e.target.value)}
                >
                  <MenuItem value={"BNB"}>BNB</MenuItem>
                  <MenuItem value={"BTC"}>BTC</MenuItem>
                  <MenuItem value={"TRX"}>TRX</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Checkbox
                checked={isToken}
                onChange={(e) => setToken(e.target.checked)}
              />
              Is Token Transfer
              {isToken && (
                <TextField
                  label="Contract Address"
                  defaultValue={tokenAddress}
                  onChange={(e) => setTokenAddress(e.target.value)}
                  fullWidth
                />
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button type="submit" fullWidth variant="contained">
                Withdraw Now
              </Button>
            </Grid>
          </Grid>
        </form>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            hanldeDeposit();
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer ID"
                defaultValue={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Email"
                type="email"
                defaultValue={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Wallet Type
                </InputLabel>
                <Select
                  value={type}
                  label="Wallet Type"
                  onChange={(e) => setType(e.target.value)}
                >
                  <MenuItem value={"BNB"}>BNB</MenuItem>
                  <MenuItem value={"BTC"}>BTC</MenuItem>
                  <MenuItem value={"TRX"}>TRX</MenuItem>
                  <MenuItem value={"USDT"}>USDT</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button
                onClick={() => {
                  hanldeCreate();
                }}
                fullWidth
                variant="contained"
              >
                Create Now
              </Button>
            </Grid>
          </Grid>
        </form>
      </TabPanel>
      <TabPanel value={value} index={4}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleBuyRequest();
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer ID"
                defaultValue={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Name"
                defaultValue={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Email"
                type="email"
                defaultValue={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Phone"
                defaultValue={customerPhone}
                onChange={(e) => setCustomerPhone(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Wallet Type
                </InputLabel>
                <Select
                  value={type}
                  label="Wallet Type"
                  onChange={(e) => setType(e.target.value)}
                >
                  <MenuItem value={"BNB"}>BNB</MenuItem>
                  <MenuItem value={"BTC"}>BTC</MenuItem>
                  <MenuItem value={"TRX"}>TRX</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Wallet Address"
                defaultValue={address}
                onChange={(e) => setAddress(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button type="submit" fullWidth variant="contained">
                Buy Token
              </Button>
            </Grid>
          </Grid>
        </form>
      </TabPanel>
      <TabPanel value={value} index={5}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleInternalRequest();
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer ID"
                defaultValue={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Name"
                defaultValue={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Email"
                type="email"
                defaultValue={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Customer Phone"
                defaultValue={customerPhone}
                onChange={(e) => setCustomerPhone(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Wallet Type
                </InputLabel>
                <Select
                  value={type}
                  label="Wallet Type"
                  onChange={(e) => setType(e.target.value)}
                >
                  <MenuItem value={"BNB"}>BNB</MenuItem>
                  <MenuItem value={"BTC"}>BTC</MenuItem>
                  <MenuItem value={"TRX"}>TRX</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Wallet Address"
                defaultValue={address}
                onChange={(e) => setAddress(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button type="submit" fullWidth variant="contained">
                Transact
              </Button>
            </Grid>
          </Grid>
        </form>
      </TabPanel>
    </Box>
  );
}
